// Pure helpers for the Scan comparison page: the headline, counters, filters, and picking two runs from the history strip.
export const STATUS = {
  new: { label: 'NEW', color: '#ef4444' },
  regressed: { label: 'GOT WORSE', color: '#f97316' },
  resolved: { label: 'FIXED', color: '#22c55e' },
  improved: { label: 'IMPROVED', color: '#38bdf8' },
  unchanged: { label: 'STILL OPEN', color: '#f59e0b' }
};
export const TABS = [
  { id: 'all', label: 'All', test: () => true },
  { id: 'new', label: 'New', test: (r) => r.status === 'new' },
  { id: 'resolved', label: 'Fixed', test: (r) => r.status === 'resolved' },
  { id: 'regressed', label: 'Got worse', test: (r) => r.status === 'regressed' },
  { id: 'open', label: 'Still open', test: (r) => r.status === 'unchanged' || r.status === 'improved' }
];

export const filterRows = (rows, tab) => rows.filter((TABS.find((t) => t.id === tab) || TABS[0]).test);
export const tabCount = (rows, id) => filterRows(rows, id).length;

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

// Four counters under the headline.
export function counters(stats) {
  const open = (stats.unchanged || 0) + (stats.improved || 0);
  return [
    { key: 'new', label: 'New', value: stats.new || 0, note: 'appeared since', color: '#fca5a5' },
    { key: 'resolved', label: 'Fixed', value: stats.resolved || 0, note: 'gone since', color: '#4ade80' },
    { key: 'regressed', label: 'Got worse', value: stats.regressed || 0, note: 'higher severity now', color: '#fdba74' },
    { key: 'open', label: 'Still open', value: open, note: 'in both runs', color: '#fcd34d' }
  ];
}

// "14 problems were fixed, but 6 new ones appeared and 2 got worse."
export function headline(stats) {
  const fixed = stats.resolved || 0;
  const fresh = stats.new || 0;
  const worse = stats.regressed || 0;
  if (!fixed && !fresh && !worse) return { tone: 'neutral', text: 'Nothing changed between these two runs.' };
  const bad = [fresh && `${plural(fresh, 'new one appeared', 'new ones appeared')}`, worse && `${worse} got worse`].filter(Boolean).join(' and ');
  if (fixed && !bad) return { tone: 'good', text: `Good news: ${plural(fixed, 'problem was', 'problems were')} fixed and nothing new or worse appeared.` };
  if (!fixed) return { tone: 'bad', text: `Nothing was fixed. ${bad[0].toUpperCase()}${bad.slice(1)}.` };
  return { tone: fresh || worse >= fixed ? 'bad' : 'neutral', text: `${plural(fixed, 'problem was', 'problems were')} fixed, but ${bad}.` };
}

// History strip: click up to two runs; a third click drops the oldest pick.
export const toggleRun = (selected, id) => (selected.includes(id) ? selected.filter((x) => x !== id) : selected.length < 2 ? [...selected, id] : [selected[1], id]);
export const defaultSelection = (runs) => runs.slice(-2).map((r) => r.id);
// Older of the two picks is the baseline, the newer one is "now".
export function pair(selected, runs) {
  const picked = runs.filter((r) => selected.includes(r.id)).sort((a, b) => new Date(a.date) - new Date(b.date));
  return picked.length === 2 ? { baseline: picked[0], current: picked[1] } : null;
}
export const barScale = (runs) => Math.max(1, ...runs.map((r) => r.findings));
export const seriesLabel = (g, typeLabel) => `${typeLabel(g.scan_type)} on ${g.address} · ${g.runs} run${g.runs === 1 ? '' : 's'}`;
